import { jsx as d } from "react/jsx-runtime";
const x = ({
  href: r,
  openNewTab: k,
  alternativeAction: b,
  onAlternativeAction: p,
  value: m = ""
}) => r ? /* @__PURE__ */ d("a", { href: r, ...k && { target: "_blank", rel: "noopener" }, children: b }) : /* @__PURE__ */ d("button", { onClick: () => p == null ? void 0 : p(m), children: b });
export {
  x as AlternativeAction
};
